module.exports = __webpack_public_path__ + "static/cardbg-850fd9903f61daab0c909a96a760455c.png";